import { ProfileFollowResponseDto } from '@diritto/common/account/dtos/profile-follow.dtos';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class ProfileFollowApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async followProfile(profileId: number) {
    const res = await this.http.post<undefined, ResponseDto>(`${this.url}/accounts/profiles/${profileId}/follow`);
    return res.data;
  }

  async unFollowProfile(profileId: number) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/accounts/profiles/${profileId}/follow`);
    return res.data;
  }

  async getFollowProfile(profileId: number) {
    const res = await this.http.get<ProfileFollowResponseDto>(`${this.url}/accounts/profiles/${profileId}/follow`);
    return res.data;
  }
}
